export const EXDefaultImage = "https://viewnia-static.s3.us-east-2.amazonaws.com/cover2.jpg";
export const DefaultImage = "https://viewnia-static.s3.us-east-2.amazonaws.com/cover.jpg";

